import { forwardRef } from 'react';
import cn from 'classnames';

const BasicInput = forwardRef(({
  title,
  placeholder,
  disabled = false,
  error = false,
  prefix,
  className,
  containerClassName,
  titleClassName,
  children,
  prefixClassName,
  inputClassName,
  ...props
}, ref) => {
  const { type } = props;
  return (
    <div className={cn("flex-col justify-start items-start gap-1 inline-flex", containerClassName)}>
      {title && (
        <div className="justify-center items-center gap-1 inline-flex">
          <div className={cn("text-[#111111] text-sm font-normal leading-[21px]", titleClassName)}>
            {title}
          </div>
        </div>
      )}
      <div className={cn("relative w-full", className)}>
        {prefix && (
          <span 
            className={cn("absolute left-3 top-1/2 -translate-y-1/2 text-[#aaaaaa] pointer-events-none", prefixClassName)}
          >
            {prefix}
          </span>
        )}
        <input
          ref={ref}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(
            "w-full h-12 rounded-md border text-sm font-normal leading-[21px] outline-none",
            {
              "bg-[#f7f7f7] border-[#dddddd]": !disabled && !error,
              "bg-[#eeeeee] border-[#dddddd]": disabled,
              "bg-[#f7f7f7] border-[#ff5501]": error,
              "hover:border-[#111111] focus:border-[#111111]": !disabled && !error,
              "hover:border-[#ff5501] focus:border-[#ff5501]": !disabled && error,
            },
            "placeholder:text-[#aaaaaa] text-[#111111]",
            prefix ? 'pl-7 pr-3' : 'px-3',
            type == 'number' && 'appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
            inputClassName
          )}
          {...props}
        />
        {children}
      </div>
      {error && typeof error === 'string' && (
        <div className="self-stretch pt-0.5 justify-start items-center gap-1 inline-flex">
          <div className="grow shrink basis-0 text-[#ff5501] text-xs font-normal leading-[18px]">
            {error}
          </div>
        </div>
      )}
    </div>
  );
});

BasicInput.displayName = 'BasicInput';

export default BasicInput; 